import "../styles/footer.css";
import logo from "../../../Assets/1631384131304.png";

function Footer() {
  return (
    <footer>
      <p>Katrori-ITS</p>
    </footer>
  );
}

export default Footer;
